// SET GLOBAL EVENT CONFIGURATION HERE
export const CAPACITY = 100;
export const DEADLINE = new Date("February 23, 2024 23:59 CDT");